<template>
  <header class="app-header" :style="headerStyle">
    <div class="app-header__row">
      <div class="app-header__left">
        <slot name="left">
          <button
            v-if="showBack"
            type="button"
            class="app-header__icon-btn"
            @click="onBack"
          >
            <i class="el-icon-arrow-left"></i>
          </button>
        </slot>
      </div>

      <div class="app-header__title" :title="title">{{ title }}</div>

      <div class="app-header__right">
        <slot name="right">
          <button
            v-if="rightText"
            type="button"
            class="app-header__text-btn"
            @click="$emit('right')"
          >
            {{ rightText }}
          </button>
          <span v-else class="app-header__placeholder" />
        </slot>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'pinia'
import { useGlobalStore } from '@/stores/global'

/**
 * 通用顶部栏：适配小程序 web-view / App 内嵌 H5 的 statusBarHeight
 * - 固定定位，不随内容滚动
 * - 通过 paddingTop 兼容刘海屏与小程序状态栏
 */
export default {
  name: 'AppHeader',
  props: {
    /** 标题 */
    title: { type: String, default: '' },
    /** 是否显示默认返回按钮 */
    showBack: { type: Boolean, default: true },
    /** 右侧文字按钮 */
    rightText: { type: String, default: '' }
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    headerStyle() {
      const top = Number(this.statusBarHeight || 0)
      return { paddingTop: top + 'px' }
    }
  },
  methods: {
    /**
     * 返回：父组件传了 @back 时只派发事件，避免与默认 go(-1) 叠加连退两级
     * @returns {void}
     */
    onBack() {
      if (this.$listeners && this.$listeners.back) {
        this.$emit('back')
        return
      }
      if (this.$router && typeof this.$router.go === 'function') {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}

.app-header__row {
  position: relative;
  height: 48px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.app-header__left,
.app-header__right {
  position: relative;
  z-index: 1;
  width: 72px;
  display: flex;
  align-items: center;
}

.app-header__left {
  justify-content: flex-start;
}

.app-header__right {
  justify-content: flex-end;
}

.app-header__title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: calc(100% - 160px);
  margin: 0;
  text-align: center;
  font-size: 17px;
  font-weight: 700;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

.app-header__icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.app-header__text-btn {
  border: none;
  background: transparent;
  font-size: 15px;
  color: #00c275;
  font-weight: 600;
  padding: 6px 5px;
}

.app-header__placeholder {
  width: 48px;
  height: 1px;
}
</style>




// WEBPACK FOOTER //
// src/components/AppHeader.vue